import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW4000Component } from './kymw4000.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW4001Module } from '../kymw4001/kymw4001.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { FormsModule } from '@angular/forms';
import { OutputPromotionPlanGoodsListService } from './api-services/output-promotion-plan-goods-list.service';

/**
 * 週次プロモーション商品計画表画面 モジュール設定クラス
 *
 * @export KYMW4000Module
 * @class KYMW4000Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    KYMW4001Module,
  ],
  declarations: [
    KYMW4000Component,
  ],
  providers: [
    OutputPromotionPlanGoodsListService,
  ],
})

export class KYMW4000Module { }
